module.exports = __webpack_public_path__ + "static/img/kuaijie.a820714.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/new4/kuaijie.png
// module id = d02G
// module chunks = 5